import {Alert, AlertTitle} from '@mui/material'
import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'

import {useItalySlotBannerDismissAlert} from '../hooks/useItalySlotBannerDismissAlert'

export const TimeSlotAlert = () => {
  const [open, setOpen] = useState(true)
  const {t: translate} = useTranslation()
  const {bannerState, dismissBanner, isLoading} = useItalySlotBannerDismissAlert()

  const handleCloseBanner = () => {
    dismissBanner()
    setOpen(false)
  }

  if (!open || isLoading || bannerState?.status === 'dismissed') return null

  return (
    <Alert
      onClose={handleCloseBanner}
      severity="info"
      sx={{
        backgroundColor: '#1e1f21',
        color: '#fff',
        width: '100%',
        '& .MuiAlert-icon': {display: 'none'},
        '& .MuiAlert-action': {color: '#ccc'}
      }}
    >
      <AlertTitle sx={{color: '#fff', fontWeight: 'bold'}}>
        {translate('orderIntake.rmc.steps.shared.validationErrors.pickASlotAlertTitle')}
      </AlertTitle>
      {translate('orderIntake.rmc.steps.shared.validationErrors.pickASlotAlert')}
    </Alert>
  )
}
